// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import PdfPreview from "../../../Common/PDFPreview";
// import { RingLoader } from 'react-spinners';
// import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount"
// import BackButton from "../../../Common/Buttons/BackButton";

// const API_URL = process.env.REACT_APP_API;

// const StockBookReport = () => {
//   const location = useLocation();
//   // const { itemCode,fromDate, toDate } = location.state;
//   const companyCode = sessionStorage.getItem("Company_Code");
//   const Year_Code = sessionStorage.getItem("Year_Code");
//   const companyName = sessionStorage.getItem('Company_Name')

//   const searchParams = new URLSearchParams(location.search);
//   const itemCode = searchParams.get('itemCode');
//   const toDate = searchParams.get('toDate');
//   const fromDate = searchParams.get('fromDate');

//   const [groupedData, setGroupedData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [pdfPreview, setPdfPreview] = useState([])
//   const [showPreview, setShowPreview] = useState(false);

//   const navigate = useNavigate();

//   const groupBy = (array, key) => {
//     const grouped = array.reduce((result, currentItem) => {
//       const groupKey = currentItem[key];
//       if (!result[groupKey]) {
//         result[groupKey] = [];
//       }
//       result[groupKey].push(currentItem);
//       return result;
//     }, {});

//     const sortedKeys = Object.keys(grouped).sort((a, b) =>
//       a.localeCompare(b)
//     );

//     const sortedGrouped = {};
//     sortedKeys.forEach((key) => {
//       sortedGrouped[key] = grouped[key];
//     });

//     return sortedGrouped;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}/${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}/${date.getFullYear()}`;
//   };

//   useEffect(() => {

//     const fetchStockBookReport = async () => {
//       try {
//         const response = await fetch(
//           `${API_URL}/report-stock-book?fromDate=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}&ToDate=${toDate}&Year_Code=${Year_Code} `
//         );
//         const result = await response.json();
//         const filteredData = result.data.filter((item) => {
//           const docDate = new Date(item.doc_date);
//           const from = new Date(fromDate);
//           const to = new Date(toDate);
//           return docDate >= from && docDate <= to;
//         });

//         const grouped = groupBy(filteredData, "item_name");
//         setGroupedData(grouped);
//       } catch (error) {
//         console.error("Error fetching stock book report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStockBookReport();
//   }, [toDate]);

//   const handleBack = () => {
//     navigate('/stock-book')
//   }

//   const generatePDF = () => {
//     const doc = new jsPDF("landscape", "mm", "a4");
//     const pageHeight = doc.internal.pageSize.height;
//     const margin = 10;
//     const pageWidth = doc.internal.pageSize.width;

//     doc.setFontSize(14);
//     doc.setFont("helvetica", "bold");
//     const companyNameWidth = doc.getTextWidth(companyName || "Company Name");
//     const companyNameX = (pageWidth - companyNameWidth) / 2;
//     doc.text(companyName, companyNameX, 10);

//     doc.setFontSize(12);
//     doc.setFont("helvetica", "normal");
//     const titleWidth = doc.getTextWidth("Stock Book Report");
//     const titleX = (pageWidth - titleWidth) / 2;
//     doc.text("Stock Book Report", titleX, 18);

//     doc.setFontSize(10);
//     const dateRangeText = `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`;
//     const dateRangeWidth = doc.getTextWidth(dateRangeText);
//     const dateRangeX = (pageWidth - dateRangeWidth) / 2;
//     doc.text(dateRangeText, dateRangeX, 24);

//     let currentY = 34;
//     Object.keys(groupedData).forEach((group, groupIndex) => {
//       if (currentY + 20 > pageHeight - margin) {
//         doc.addPage();
//         currentY = margin;
//       }

//       doc.setFontSize(12);
//       doc.setTextColor(40);

//       doc.setFontSize(12);
//       doc.setFont("helvetica", "normal");
//       const titleWidth = doc.getTextWidth("Stock Book Report");
//       const titleX = (pageWidth - titleWidth) / 2
//       doc.text(`Item Name: ${group.toUpperCase()}`, titleX, currentY);
//       currentY += 10;

//       const tableData = groupedData[group].map((row) => [
//         formatDate(row.doc_date),
//         formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
//       ]);


//       const totalRow = [
//         "Total",
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.op_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.op_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.close_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.close_val) || 0), 0)
//           .toFixed(2)),
//       ];


//       doc.autoTable({
//         startY: currentY,
//         head: [
//           [
//             "Date",
//             "Opening Qty",
//             "Opening Value",
//             "Purchase Qty",
//             "Purchase Value",
//             "Sale Qty",
//             "Sale Value",
//             "Closing Qty",
//             "Closing Value",
//           ],
//         ],
//         body: [...tableData, totalRow],
//         styles: { fontSize: 8, cellPadding: 3, halign: "right" },
//         headStyles: { fillColor: [240, 240, 240], textColor: 0 },
//         columnStyles: { 0: { halign: "center" } },
//         didDrawPage: (data) => {
//           currentY = data.cursor.y;
//         },
//       });

//       currentY = doc.lastAutoTable.finalY + 10;
//     });

//     const pdfBlob = doc.output("blob");
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     setPdfPreview(pdfUrl);
//     setShowPreview(true);
//   };

//   if (loading) return <div>{loading && (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100%",
//       }}
//     >
//       <RingLoader />
//     </div>
//   )}
//   </div>;

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <div className="d-flex mb-3 mt-0.5">
//         <BackButton onClick={handleBack} />
//         {showPreview && pdfPreview && (
//           <PdfPreview pdfData={pdfPreview} apiData={groupedData} label={"Stock-Report"} />
//         )}
//         <button
//           onClick={generatePDF}
//           className="print-button"
//           style={{ fontSize: "16px", height: "50px", marginTop: "10px" }}
//         >
//           PDF Preview
//         </button>
//       </div>
//       <h2 style={{ textAlign: "center", marginBottom: "5px", color: "#333", marginTop: "-60px" }}>
//         {companyName}
//       </h2>
//       <p style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
//         <strong>Stock Book Report From Date:</strong> {formatDate(fromDate)} |{" "}
//         <strong>To Date:</strong> {formatDate(toDate)}
//       </p>
//       {Object.keys(groupedData).map((group, index) => (
//         <div key={index} style={{ marginBottom: "30px" }}>
//           <h3 style={{ backgroundColor: "#f4f4f4", padding: "10px", textAlign: "left" }}>
//             {group.toUpperCase()}
//           </h3>
//           <table
//             border="1"
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               fontSize: "14px",
//             }}
//           >
//             <thead>
//               <tr>
//                 <th rowSpan="2" style={{ textAlign: "center", padding: "10px" }}>
//                   Date
//                 </th>
//                 <th colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
//                   Opening
//                 </th>
//                 <th colSpan="1" style={{ textAlign: "center", padding: "10px" }}>
//                   Purchase
//                 </th>
//                 <th colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
//                   Sale
//                 </th>
//                 <th colSpan="1" style={{ textAlign: "center", padding: "10px" }}>
//                   Closing
//                 </th>

//                 <th style={{ textAlign: "center", padding: "10px" }}>
//                   Day Diff
//                 </th>
//               </tr>
//               <tr>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//                 <th style={{ textAlign: "center", padding: "10px" }}>Quantity</th>
//               </tr>
//             </thead>
//             <tbody>
//               {groupedData[group].map((row, rowIndex) => (
//                 <tr
//                   key={rowIndex}
//                   style={{
//                     backgroundColor: rowIndex % 2 === 0 ? "#f9f9f9" : "white",
//                   }}
//                 >
//                   <td style={{ textAlign: "center" }}>{formatDate(row.doc_date)}</td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2))}
//                   </td>

//                   <td style={{ textAlign: "center" }}>
//                     {formatReadableAmount(
//                       (
//                         (parseFloat(row.purc_qty) || 0) -
//                         (parseFloat(row.sale_qty) || 0)
//                       ).toFixed(2)
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//             <tfoot style={{ backgroundColor: "#e0e0e0", fontWeight: "bold" }}>
//               <tr>
//                 <td style={{ textAlign: "center" }}>Total</td>
//                 <td style={{ textAlign: "right" }}>
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(groupedData[group]
//                     .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//                     .toFixed(2))}
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(groupedData[group]
//                     .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//                     .toFixed(2))}
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(groupedData[group]
//                     .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//                     .toFixed(2))}
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(groupedData[group]
//                     .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//                     .toFixed(2))}
//                 </td>
//               </tr>
//             </tfoot>
//           </table>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default StockBookReport;





















// import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import * as XLSX from 'xlsx';
// import PdfPreview from "../../../Common/PDFPreview";
// import { RingLoader } from 'react-spinners';
// import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount"
// import BackButton from "../../../Common/Buttons/BackButton";

// const API_URL = process.env.REACT_APP_API;

// const StockBookReport = () => {
//   const location = useLocation();
//   const companyCode = sessionStorage.getItem("Company_Code");
//   const Year_Code = sessionStorage.getItem("Year_Code");
//   const companyName = sessionStorage.getItem('Company_Name')

//   const searchParams = new URLSearchParams(location.search);
//   const itemCode = searchParams.get('itemCode');
//   const toDate = searchParams.get('toDate');
//   const fromDate = searchParams.get('fromDate');

//   const [groupedData, setGroupedData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [pdfPreview, setPdfPreview] = useState([])
//   const [showPreview, setShowPreview] = useState(false);
//   const reportRef = useRef();

//   const navigate = useNavigate();

//   const groupBy = (array, key) => {
//     const grouped = array.reduce((result, currentItem) => {
//       const groupKey = currentItem[key];
//       if (!result[groupKey]) {
//         result[groupKey] = [];
//       }
//       result[groupKey].push(currentItem);
//       return result;
//     }, {});

//     const sortedKeys = Object.keys(grouped).sort((a, b) =>
//       a.localeCompare(b)
//     );

//     const sortedGrouped = {};
//     sortedKeys.forEach((key) => {
//       sortedGrouped[key] = grouped[key];
//     });

//     return sortedGrouped;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}/${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}/${date.getFullYear()}`;
//   };

//   useEffect(() => {
//     const fetchStockBookReport = async () => {
//       try {
//         const response = await fetch(
//           `${API_URL}/report-stock-book?fromDate=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}&ToDate=${toDate}&Year_Code=${Year_Code} `
//         );
//         const result = await response.json();
//         const filteredData = result.data.filter((item) => {
//           const docDate = new Date(item.doc_date);
//           const from = new Date(fromDate);
//           const to = new Date(toDate);
//           return docDate >= from && docDate <= to;
//         });

//         const grouped = groupBy(filteredData, "item_name");
//         setGroupedData(grouped);
//       } catch (error) {
//         console.error("Error fetching stock book report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStockBookReport();
//   }, [toDate, fromDate, companyCode, Year_Code, itemCode]);

//   const handleBack = () => {
//     navigate('/stock-book')
//   }

//   const handlePrint = () => {
//     const printContent = reportRef.current.innerHTML;
//     const originalTitle = document.title;
//     const printWindow = window.open('', '_blank');

//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Stock Book Report - ${companyName}</title>
//           <style>
//             body {
//               font-family: Arial, sans-serif;
//               margin: 20px;
//               padding: 20px;
//             }
//             .header {
//               text-align: center;
//               margin-bottom: 30px;
//             }
//             .company-name {
//               font-size: 20px;
//               font-weight: bold;
//               margin-bottom: 10px;
//             }
//             .report-title {
//               font-size: 16px;
//               font-weight: bold;
//               margin-bottom: 10px;
//             }
//             .date-range {
//               font-size: 12px;
//               margin-bottom: 20px;
//             }
//             table {
//               width: 100%;
//               border-collapse: collapse;
//               margin-bottom: 30px;
//               page-break-inside: avoid;
//             }
//             th, td {
//               border: 1px solid #000;
//               padding: 8px;
//               text-align: right;
//             }
//             th:first-child, td:first-child {
//               text-align: center;
//             }
//             th {
//               background-color: #f4f4f4;
//               font-weight: bold;
//             }
//             .item-header {
//               background-color: #e0e0e0;
//               padding: 10px;
//               margin-top: 20px;
//               margin-bottom: 10px;
//               font-weight: bold;
//             }
//             tfoot td {
//               background-color: #e0e0e0;
//               font-weight: bold;
//             }
//             @media print {
//               body {
//                 margin: 0;
//                 padding: 10px;
//               }
//               button {
//                 display: none;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//         </body>
//       </html>
//     `);

//     printWindow.document.close();
//     printWindow.print();
//     printWindow.close();
//   };

//   const exportToExcel = () => {
//     const excelData = [];

//     // Add header information
//     excelData.push(['Company Name', companyName]);
//     excelData.push(['Report', 'Stock Book Report']);
//     excelData.push(['From Date', formatDate(fromDate)]);
//     excelData.push(['To Date', formatDate(toDate)]);
//     excelData.push([]); // Empty row for spacing

//     // Process each item group
//     Object.keys(groupedData).forEach((group) => {
//       // Add item name as header
//       excelData.push([`Item: ${group.toUpperCase()}`]);
//       excelData.push([]);

//       // Add table headers
//       excelData.push([
//         'Date',
//         'Opening Qty (Quintals)',
//         'Opening Value',
//         'Purchase Qty (Quintals)',
//         'Purchase Value',
//         'Sale Qty (Quintals)',
//         'Sale Value',
//         'Closing Qty (Quintals)',
//         'Closing Value',
//         'Day Diff'
//       ]);

//       // Add data rows
//       groupedData[group].forEach((row) => {
//         excelData.push([
//           formatDate(row.doc_date),
//           formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
//           formatReadableAmount(
//             ((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)
//           )
//         ]);
//       });

//       // Add total row
//       excelData.push([
//         'TOTAL',
//         '',
//         '',
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//           .toFixed(2)),
//         '',
//         '',
//         ''
//       ]);

//       excelData.push([]); // Empty row between items
//       excelData.push([]); // Empty row between items
//     });

//     // Create worksheet and workbook
//     const ws = XLSX.utils.aoa_to_sheet(excelData);

//     // Set column widths
//     ws['!cols'] = [
//       { wch: 12 }, // Date
//       { wch: 18 }, // Opening Qty
//       { wch: 15 }, // Opening Value
//       { wch: 18 }, // Purchase Qty
//       { wch: 15 }, // Purchase Value
//       { wch: 15 }, // Sale Qty
//       { wch: 15 }, // Sale Value
//       { wch: 18 }, // Closing Qty
//       { wch: 15 }, // Closing Value
//       { wch: 12 }  // Day Diff
//     ];

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Stock Book Report');

//     // Generate Excel file
//     const fileName = `Stock_Book_Report_${formatDate(fromDate)}_to_${formatDate(toDate)}.xlsx`;
//     XLSX.writeFile(wb, fileName);
//   };

//   const generatePDF = () => {
//     const doc = new jsPDF("landscape", "mm", "a4");
//     const pageHeight = doc.internal.pageSize.height;
//     const margin = 10;
//     const pageWidth = doc.internal.pageSize.width;

//     doc.setFontSize(14);
//     doc.setFont("helvetica", "bold");
//     const companyNameWidth = doc.getTextWidth(companyName || "Company Name");
//     const companyNameX = (pageWidth - companyNameWidth) / 2;
//     doc.text(companyName, companyNameX, 10);

//     doc.setFontSize(12);
//     doc.setFont("helvetica", "normal");
//     const titleWidth = doc.getTextWidth("Stock Book Report");
//     const titleX = (pageWidth - titleWidth) / 2;
//     doc.text("Stock Book Report", titleX, 18);

//     doc.setFontSize(10);
//     const dateRangeText = `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`;
//     const dateRangeWidth = doc.getTextWidth(dateRangeText);
//     const dateRangeX = (pageWidth - dateRangeWidth) / 2;
//     doc.text(dateRangeText, dateRangeX, 24);

//     let currentY = 34;
//     Object.keys(groupedData).forEach((group, groupIndex) => {
//       if (currentY + 20 > pageHeight - margin) {
//         doc.addPage();
//         currentY = margin;
//       }

//       doc.setFontSize(12);
//       doc.setTextColor(40);
//       doc.setFont("helvetica", "bold");
//       const itemText = `Item Name: ${group.toUpperCase()}`;
//       const itemTextWidth = doc.getTextWidth(itemText);
//       const itemTextX = (pageWidth - itemTextWidth) / 2;
//       doc.text(itemText, itemTextX, currentY);
//       currentY += 10;

//       const tableData = groupedData[group].map((row) => [
//         formatDate(row.doc_date),
//         formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
//         formatReadableAmount(((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)),
//       ]);

//       const totalRow = [
//         "Total",
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.op_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.op_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.close_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(groupedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.close_val) || 0), 0)
//           .toFixed(2)),
//         "",
//       ];

//       doc.autoTable({
//         startY: currentY,
//         head: [
//           [
//             "Date",
//             "Opening Qty",
//             "Opening Value",
//             "Purchase Qty",
//             "Purchase Value",
//             "Sale Qty",
//             "Sale Value",
//             "Closing Qty",
//             "Closing Value",
//             "Day Diff",
//           ],
//         ],
//         body: [...tableData, totalRow],
//         styles: { fontSize: 8, cellPadding: 3, halign: "right" },
//         headStyles: { fillColor: [240, 240, 240], textColor: 0, halign: "center" },
//         columnStyles: { 
//           0: { halign: "center" },
//           9: { halign: "right" }
//         },
//         didDrawPage: (data) => {
//           currentY = data.cursor.y;
//         },
//       });

//       currentY = doc.lastAutoTable.finalY + 10;
//     });

//     const pdfBlob = doc.output("blob");
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     setPdfPreview(pdfUrl);
//     setShowPreview(true);
//   };

//   if (loading) return (
//     <div style={{
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       height: "100vh",
//     }}>
//       <RingLoader />
//     </div>
//   );

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <div className="d-flex mb-3 mt-0.5" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//         <BackButton onClick={handleBack} />
//         {showPreview && pdfPreview && (
//           <PdfPreview pdfData={pdfPreview} apiData={groupedData} label={"Stock-Report"} />
//         )}
//         {/* <button
//           onClick={generatePDF}
//           className="print-button"
//           style={{ fontSize: "14px", padding: "10px 20px", height: "50px", marginTop: "10px", cursor: "pointer" }}
//         >
//           PDF Preview
//         </button> */}
//         <button
//           onClick={handlePrint}
//           className="print-button"
//           style={{ fontSize: "14px", padding: "10px 20px", height: "50px", marginTop: "10px", cursor: "pointer", backgroundColor: "#4CAF50", color: "white", border: "none", borderRadius: "4px" }}
//         >
//           Print
//         </button>
//         <button
//           onClick={exportToExcel}
//           className="excel-button"
//           style={{ fontSize: "14px", padding: "10px 20px", height: "50px", marginTop: "10px", cursor: "pointer", backgroundColor: "#2196F3", color: "white", border: "none", borderRadius: "4px" }}
//         >
//           Export to Excel
//         </button>
//       </div>

//       {/* Report Content for Printing */}
//       <div ref={reportRef}>
//         <div className="header" style={{ textAlign: "center", marginBottom: "20px" }}>
//           <h2 style={{ marginBottom: "5px", color: "#333" }}>
//             {companyName}
//           </h2>
//           <h3 style={{ marginBottom: "10px", color: "#555" }}>
//             Stock Book Report
//           </h3>
//           <p style={{ fontSize: "14px", marginBottom: "20px" }}>
//             <strong>From Date:</strong> {formatDate(fromDate)} |{" "}
//             <strong>To Date:</strong> {formatDate(toDate)}
//           </p>
//         </div>

//         {Object.keys(groupedData).map((group, index) => (
//           <div key={index} style={{ marginBottom: "30px" }}>
//             <h3 style={{ backgroundColor: "#f4f4f4", padding: "10px", textAlign: "left", marginBottom: "10px" }}>
//               {group.toUpperCase()}
//             </h3>
//             <table
//               border="1"
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "12px",
//               }}
//             >
//               <thead>
//                 <tr>
//                   <th rowSpan="2" style={{ textAlign: "center", padding: "8px", verticalAlign: "middle" }}>
//                     Date
//                   </th>
//                   <th colSpan="2" style={{ textAlign: "center", padding: "8px", backgroundColor: "#e8f4f8" }}>
//                     Opening
//                   </th>
//                   <th colSpan="2" style={{ textAlign: "center", padding: "8px", backgroundColor: "#d4edda" }}>
//                     Purchase
//                   </th>
//                   <th colSpan="2" style={{ textAlign: "center", padding: "8px", backgroundColor: "#f8d7da" }}>
//                     Sale
//                   </th>
//                   <th colSpan="2" style={{ textAlign: "center", padding: "8px", backgroundColor: "#fff3cd" }}>
//                     Closing
//                   </th>
//                   <th rowSpan="2" style={{ textAlign: "center", padding: "8px", verticalAlign: "middle", backgroundColor: "#d1ecf1" }}>
//                     Day Diff
//                   </th>
//                 </tr>
//                 <tr>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Qty (Qtls)</th>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Value (₹)</th>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Qty (Qtls)</th>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Value (₹)</th>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Qty (Qtls)</th>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Value (₹)</th>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Qty (Qtls)</th>
//                   <th style={{ textAlign: "right", padding: "8px" }}>Value (₹)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {groupedData[group].map((row, rowIndex) => (
//                   <tr
//                     key={rowIndex}
//                     style={{
//                       backgroundColor: rowIndex % 2 === 0 ? "#f9f9f9" : "white",
//                     }}
//                   >
//                     <td style={{ textAlign: "center", padding: "6px" }}>{formatDate(row.doc_date)}</td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "center", padding: "6px" }}>
//                       {formatReadableAmount(
//                         ((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot style={{ backgroundColor: "#e0e0e0", fontWeight: "bold" }}>
//                 <tr>
//                   <td style={{ textAlign: "center", padding: "8px" }}>Total</td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>-</td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>-</td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>
//                     {formatReadableAmount(groupedData[group]
//                       .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//                       .toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>
//                     {formatReadableAmount(groupedData[group]
//                       .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//                       .toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>
//                     {formatReadableAmount(groupedData[group]
//                       .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//                       .toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>
//                     {formatReadableAmount(groupedData[group]
//                       .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//                       .toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>-</td>
//                   <td style={{ textAlign: "right", padding: "8px" }}>-</td>
//                   <td style={{ textAlign: "center", padding: "8px" }}>-</td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default StockBookReport;





















// import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import * as XLSX from 'xlsx';
// import PdfPreview from "../../../Common/PDFPreview";
// import { RingLoader } from 'react-spinners';
// import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount"
// import BackButton from "../../../Common/Buttons/BackButton";

// const API_URL = process.env.REACT_APP_API;

// const StockBookReport = () => {
//   const location = useLocation();
//   const companyCode = sessionStorage.getItem("Company_Code");
//   const Year_Code = sessionStorage.getItem("Year_Code");
//   const companyName = sessionStorage.getItem('Company_Name')

//   const searchParams = new URLSearchParams(location.search);
//   const itemCode = searchParams.get('itemCode');
//   const toDate = searchParams.get('toDate');
//   const fromDate = searchParams.get('fromDate');

//   const [groupedData, setGroupedData] = useState({});
//   const [sortedData, setSortedData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [pdfPreview, setPdfPreview] = useState([])
//   const [showPreview, setShowPreview] = useState(false);
//   const [sortConfig, setSortConfig] = useState({});
//   const reportRef = useRef();

//   const navigate = useNavigate();

//   const groupBy = (array, key) => {
//     const grouped = array.reduce((result, currentItem) => {
//       const groupKey = currentItem[key];
//       if (!result[groupKey]) {
//         result[groupKey] = [];
//       }
//       result[groupKey].push(currentItem);
//       return result;
//     }, {});

//     const sortedKeys = Object.keys(grouped).sort((a, b) =>
//       a.localeCompare(b)
//     );

//     const sortedGrouped = {};
//     sortedKeys.forEach((key) => {
//       sortedGrouped[key] = grouped[key];
//     });

//     return sortedGrouped;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}/${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}/${date.getFullYear()}`;
//   };

//   const sortData = (data, column, direction) => {
//     if (!data || !Array.isArray(data)) return [];

//     const sorted = [...data];

//     sorted.sort((a, b) => {
//       let aValue, bValue;

//       switch(column) {
//         case 'date':
//           aValue = new Date(a.doc_date).getTime();
//           bValue = new Date(b.doc_date).getTime();
//           break;
//         case 'opening_qty':
//           aValue = parseFloat(a.op_qty) || 0;
//           bValue = parseFloat(b.op_qty) || 0;
//           break;
//         case 'opening_value':
//           aValue = parseFloat(a.op_value) || 0;
//           bValue = parseFloat(b.op_value) || 0;
//           break;
//         case 'purchase_qty':
//           aValue = parseFloat(a.purc_qty) || 0;
//           bValue = parseFloat(b.purc_qty) || 0;
//           break;
//         case 'purchase_value':
//           aValue = parseFloat(a.purc_value) || 0;
//           bValue = parseFloat(b.purc_value) || 0;
//           break;
//         case 'sale_qty':
//           aValue = parseFloat(a.sale_qty) || 0;
//           bValue = parseFloat(b.sale_qty) || 0;
//           break;
//         case 'sale_value':
//           aValue = parseFloat(a.sale_val) || 0;
//           bValue = parseFloat(b.sale_val) || 0;
//           break;
//         case 'closing_qty':
//           aValue = parseFloat(a.close_qty) || 0;
//           bValue = parseFloat(b.close_qty) || 0;
//           break;
//         case 'closing_value':
//           aValue = parseFloat(a.close_val) || 0;
//           bValue = parseFloat(b.close_val) || 0;
//           break;
//         case 'day_diff':
//           aValue = (parseFloat(a.purc_qty) || 0) - (parseFloat(a.sale_qty) || 0);
//           bValue = (parseFloat(b.purc_qty) || 0) - (parseFloat(b.sale_qty) || 0);
//           break;
//         default:
//           aValue = a[column];
//           bValue = b[column];
//       }

//       if (direction === 'asc') {
//         if (aValue < bValue) return -1;
//         if (aValue > bValue) return 1;
//         return 0;
//       } else {
//         if (aValue > bValue) return -1;
//         if (aValue < bValue) return 1;
//         return 0;
//       }
//     });

//     return sorted;
//   };

//   const handleSort = (groupKey, column) => {
//     setSortConfig(prevConfig => {
//       const currentConfig = prevConfig[groupKey];

//       let newDirection;

//       if (!currentConfig || currentConfig.column !== column) {
//         newDirection = 'asc';
//       } else if (currentConfig.column === column && currentConfig.direction === 'asc') {
//         newDirection = 'desc';
//       } else if (currentConfig.column === column && currentConfig.direction === 'desc') {
//         newDirection = null;
//       } else {
//         newDirection = 'asc';
//       }

//       const newConfig = { ...prevConfig };

//       if (newDirection) {
//         newConfig[groupKey] = { column, direction: newDirection };
//         const sortedGroupData = sortData(groupedData[groupKey], column, newDirection);

//         setSortedData(prev => ({
//           ...prev,
//           [groupKey]: sortedGroupData
//         }));
//       } else {
//         delete newConfig[groupKey];
//         setSortedData(prev => ({
//           ...prev,
//           [groupKey]: [...groupedData[groupKey]]
//         }));
//       }

//       return newConfig;
//     });
//   };

//   const getSortIcon = (groupKey, column) => {
//     const config = sortConfig[groupKey];
//     if (config && config.column === column) {
//       return config.direction === 'asc' ? ' ↑' : ' ↓';
//     }
//     return ' ⇅';
//   };

//   useEffect(() => {
//     const fetchStockBookReport = async () => {
//       try {
//         const response = await fetch(
//           `${API_URL}/report-stock-book?fromDate=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}&ToDate=${toDate}&Year_Code=${Year_Code} `
//         );
//         const result = await response.json();
//         const filteredData = result.data.filter((item) => {
//           const docDate = new Date(item.doc_date);
//           const from = new Date(fromDate);
//           const to = new Date(toDate);
//           return docDate >= from && docDate <= to;
//         });

//         const grouped = groupBy(filteredData, "item_name");
//         setGroupedData(grouped);
//         const initialSorted = {};
//         Object.keys(grouped).forEach(key => {
//           initialSorted[key] = [...grouped[key]];
//         });
//         setSortedData(initialSorted);
//       } catch (error) {
//         console.error("Error fetching stock book report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStockBookReport();
//   }, [toDate, fromDate, companyCode, Year_Code, itemCode]);

//   const handleBack = () => {
//     navigate('/stock-book')
//   }

//   // Fixed Print Function - Landscape with better scaling
//   const handlePrint = () => {
//     const printContent = reportRef.current.cloneNode(true);

//     // Create a new window for printing
//     const printWindow = window.open('', '_blank', 'width=1200,height=800');

//     printWindow.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>Stock Book Report - ${companyName}</title>
//           <meta charset="utf-8" />
//           <style>
//             * {
//               margin: 0;
//               padding: 0;
//               box-sizing: border-box;
//             }

//             body {
//               font-family: 'Arial', 'Helvetica', sans-serif;
//               margin: 0;
//               padding: 20px;
//               background: white;
//             }

//             @page {
//               size: landscape;
//               margin: 15mm 10mm;
//             }

//             .print-container {
//               max-width: 100%;
//               margin: 0 auto;
//             }

//             .header {
//               text-align: center;
//               margin-bottom: 25px;
//               page-break-after: avoid;
//             }

//             .company-name {
//               font-size: 22px;
//               font-weight: bold;
//               margin-bottom: 8px;
//               color: #000;
//             }

//             .report-title {
//               font-size: 18px;
//               font-weight: bold;
//               margin-bottom: 8px;
//               color: #000;
//             }

//             .date-range {
//               font-size: 12px;
//               margin-bottom: 15px;
//               color: #333;
//             }

//             .item-section {
//               margin-bottom: 30px;
//               page-break-inside: avoid;
//               break-inside: avoid;
//             }

//             .item-header {
//               background-color: #f0f0f0;
//               padding: 8px 12px;
//               margin: 15px 0 10px 0;
//               font-weight: bold;
//               font-size: 14px;
//               border-left: 4px solid #2196F3;
//               page-break-after: avoid;
//             }

//             table {
//               width: 100%;
//               border-collapse: collapse;
//               font-size: 10px;
//               margin-bottom: 20px;
//               page-break-inside: avoid;
//               break-inside: avoid;
//             }

//             th, td {
//               border: 1px solid #000;
//               padding: 6px 4px;
//               text-align: right;
//             }

//             th:first-child, td:first-child {
//               text-align: center;
//             }

//             th {
//               background-color: #e0e0e0;
//               font-weight: bold;
//               font-size: 10px;
//             }

//             tbody tr:nth-child(even) {
//               background-color: #f9f9f9;
//             }

//             tfoot td {
//               background-color: #e0e0e0;
//               font-weight: bold;
//             }

//             .opening-header {
//               background-color: #e8f4f8;
//             }

//             .purchase-header {
//               background-color: #d4edda;
//             }

//             .sale-header {
//               background-color: #f8d7da;
//             }

//             .closing-header {
//               background-color: #fff3cd;
//             }

//             .daydiff-header {
//               background-color: #d1ecf1;
//             }

//             /* Ensure tables don't break across pages badly */
//             tr {
//               page-break-inside: avoid;
//               break-inside: avoid;
//             }

//             /* Responsive table container */
//             .table-wrapper {
//               overflow-x: auto;
//               width: 100%;
//               margin-bottom: 20px;
//             }

//             @media print {
//               body {
//                 padding: 0;
//                 margin: 0;
//               }

//               button, .no-print {
//                 display: none !important;
//               }

//               table {
//                 font-size: 9px;
//               }

//               th, td {
//                 padding: 4px 3px;
//               }

//               .item-section {
//                 page-break-after: avoid;
//                 break-after: avoid;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-container">
//             ${printContent.innerHTML}
//           </div>
//           <script>
//             window.onload = function() {
//               window.print();
//               window.onafterprint = function() {
//                 window.close();
//               };
//             };
//           <\/script>
//         </body>
//       </html>
//     `);

//     printWindow.document.close();
//   };

//   const exportToExcel = () => {
//     const excelData = [];

//     excelData.push(['Company Name', companyName]);
//     excelData.push(['Report', 'Stock Book Report']);
//     excelData.push(['From Date', formatDate(fromDate)]);
//     excelData.push(['To Date', formatDate(toDate)]);
//     excelData.push([]);

//     Object.keys(sortedData).forEach((group) => {
//       excelData.push([`Item: ${group.toUpperCase()}`]);
//       excelData.push([]);

//       excelData.push([
//         'Date',
//         'Opening Qty (Quintals)',
//         'Opening Value',
//         'Purchase Qty (Quintals)',
//         'Purchase Value',
//         'Sale Qty (Quintals)',
//         'Sale Value',
//         'Closing Qty (Quintals)',
//         'Closing Value',
//         'Day Diff'
//       ]);

//       sortedData[group].forEach((row) => {
//         excelData.push([
//           formatDate(row.doc_date),
//           formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
//           formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
//           formatReadableAmount(
//             ((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)
//           )
//         ]);
//       });

//       excelData.push([
//         'TOTAL',
//         '',
//         '',
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//           .toFixed(2)),
//         '',
//         '',
//         ''
//       ]);

//       excelData.push([]);
//       excelData.push([]);
//     });

//     const ws = XLSX.utils.aoa_to_sheet(excelData);

//     ws['!cols'] = [
//       { wch: 12 },
//       { wch: 18 },
//       { wch: 15 },
//       { wch: 18 },
//       { wch: 15 },
//       { wch: 15 },
//       { wch: 15 },
//       { wch: 18 },
//       { wch: 15 },
//       { wch: 12 }
//     ];

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Stock Book Report');

//     const fileName = `Stock_Book_Report_${formatDate(fromDate)}_to_${formatDate(toDate)}.xlsx`;
//     XLSX.writeFile(wb, fileName);
//   };

//   const generatePDF = () => {
//     const doc = new jsPDF("landscape", "mm", "a4");
//     const pageHeight = doc.internal.pageSize.height;
//     const margin = 10;
//     const pageWidth = doc.internal.pageSize.width;

//     doc.setFontSize(14);
//     doc.setFont("helvetica", "bold");
//     const companyNameWidth = doc.getTextWidth(companyName || "Company Name");
//     const companyNameX = (pageWidth - companyNameWidth) / 2;
//     doc.text(companyName, companyNameX, 10);

//     doc.setFontSize(12);
//     doc.setFont("helvetica", "normal");
//     const titleWidth = doc.getTextWidth("Stock Book Report");
//     const titleX = (pageWidth - titleWidth) / 2;
//     doc.text("Stock Book Report", titleX, 18);

//     doc.setFontSize(10);
//     const dateRangeText = `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`;
//     const dateRangeWidth = doc.getTextWidth(dateRangeText);
//     const dateRangeX = (pageWidth - dateRangeWidth) / 2;
//     doc.text(dateRangeText, dateRangeX, 24);

//     let currentY = 34;
//     Object.keys(sortedData).forEach((group, groupIndex) => {
//       if (currentY + 20 > pageHeight - margin) {
//         doc.addPage();
//         currentY = margin;
//       }

//       doc.setFontSize(11);
//       doc.setTextColor(40);
//       doc.setFont("helvetica", "bold");
//       const itemText = `Item Name: ${group.toUpperCase()}`;
//       const itemTextWidth = doc.getTextWidth(itemText);
//       const itemTextX = (pageWidth - itemTextWidth) / 2;
//       doc.text(itemText, itemTextX, currentY);
//       currentY += 8;

//       const tableData = sortedData[group].map((row) => [
//         formatDate(row.doc_date),
//         formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
//         formatReadableAmount(((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)),
//       ]);

//       const totalRow = [
//         "Total",
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.op_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.op_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.close_qty) || 0), 0)
//           .toFixed(2)),
//         formatReadableAmount(sortedData[group]
//           .reduce((sum, item) => sum + (parseFloat(item.close_val) || 0), 0)
//           .toFixed(2)),
//         "",
//       ];

//       doc.autoTable({
//         startY: currentY,
//         head: [
//           [
//             "Date",
//             "Opening Qty",
//             "Opening Value",
//             "Purchase Qty",
//             "Purchase Value",
//             "Sale Qty",
//             "Sale Value",
//             "Closing Qty",
//             "Closing Value",
//             "Day Diff",
//           ],
//         ],
//         body: [...tableData, totalRow],
//         styles: { fontSize: 7, cellPadding: 2, halign: "right" },
//         headStyles: { fillColor: [240, 240, 240], textColor: 0, halign: "center", fontSize: 7 },
//         columnStyles: { 
//           0: { halign: "center", cellWidth: 25 },
//           1: { cellWidth: 22 },
//           2: { cellWidth: 25 },
//           3: { cellWidth: 22 },
//           4: { cellWidth: 25 },
//           5: { cellWidth: 22 },
//           6: { cellWidth: 25 },
//           7: { cellWidth: 22 },
//           8: { cellWidth: 25 },
//           9: { halign: "right", cellWidth: 20 }
//         },
//         margin: { left: 10, right: 10 },
//         didDrawPage: (data) => {
//           currentY = data.cursor.y;
//         },
//       });

//       currentY = doc.lastAutoTable.finalY + 8;
//     });

//     const pdfBlob = doc.output("blob");
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     setPdfPreview(pdfUrl);
//     setShowPreview(true);
//   };

//   const TableHeader = ({ groupKey, column, label, style }) => (
//     <th 
//       style={{ 
//         textAlign: "right", 
//         padding: "8px", 
//         cursor: "pointer",
//         userSelect: "none",
//         position: "relative",
//         transition: "background-color 0.2s",
//         ...style
//       }}
//       onClick={() => handleSort(groupKey, column)}
//       onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e0e0e0"}
//       onMouseLeave={(e) => e.currentTarget.style.backgroundColor = style?.backgroundColor || "#f0f0f0"}
//       title={`Click to sort`}
//     >
//       {label}
//       <span style={{ marginLeft: "8px", fontSize: "11px", fontWeight: "normal" }}>
//         {getSortIcon(groupKey, column)}
//       </span>
//     </th>
//   );

//   if (loading) return (
//     <div style={{
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       height: "100vh",
//     }}>
//       <RingLoader />
//     </div>
//   );

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px' }} className="no-print">
//         <BackButton onClick={handleBack} />
//         {showPreview && pdfPreview && (
//           <PdfPreview pdfData={pdfPreview} apiData={sortedData} label={"Stock-Report"} />
//         )}
//         {/* <button
//           onClick={generatePDF}
//           style={{ fontSize: "14px", padding: "10px 20px", height: "50px", cursor: "pointer", backgroundColor: "#dc3545", color: "white", border: "none", borderRadius: "4px" }}
//         >
//           PDF Preview
//         </button> */}
//         <button
//           onClick={handlePrint}
//           style={{ fontSize: "14px", padding: "10px 20px", height: "50px", cursor: "pointer", backgroundColor: "#4CAF50", color: "white", border: "none", borderRadius: "4px" }}
//         >
//           Print
//         </button>
//         <button
//           onClick={exportToExcel}
//           style={{ fontSize: "14px", padding: "10px 20px", height: "50px", cursor: "pointer", backgroundColor: "#2196F3", color: "white", border: "none", borderRadius: "4px" }}
//         >
//           Export to Excel
//         </button>
//       </div>

//       {/* Print Content */}
//       <div ref={reportRef}>
//         <div className="header" style={{ textAlign: "center", marginBottom: "25px" }}>
//           <div style={{ fontSize: "22px", fontWeight: "bold", marginBottom: "8px" }}>
//             {companyName}
//           </div>
//           <div style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "8px" }}>
//             Stock Book Report
//           </div>
//           <div style={{ fontSize: "12px", marginBottom: "15px" }}>
//             <strong>From Date:</strong> {formatDate(fromDate)} |{" "}
//             <strong>To Date:</strong> {formatDate(toDate)}
//           </div>
//         </div>

//         {Object.keys(sortedData).map((group, index) => (
//           <div key={index} className="item-section" style={{ marginBottom: "30px" }}>
//             <div className="item-header" style={{ 
//               backgroundColor: "#f4f4f4", 
//               padding: "8px 12px", 
//               marginBottom: "10px",
//               fontWeight: "bold",
//               fontSize: "14px"
//             }}>
//               {group.toUpperCase()}
//             </div>
//             <div className="table-wrapper">
//               <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "10px" }}>
//                 <thead>
//                   <tr>
//                     <th rowSpan="2" style={{ textAlign: "center", padding: "6px", verticalAlign: "middle", backgroundColor: "#f0f0f0" }}>
//                       Date
//                     </th>
//                     <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#e8f4f8" }}>
//                       Opening
//                     </th>
//                     <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#d4edda" }}>
//                       Purchase
//                     </th>
//                     <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#f8d7da" }}>
//                       Sale
//                     </th>
//                     <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#fff3cd" }}>
//                       Closing
//                     </th>
//                     <th rowSpan="2" style={{ textAlign: "center", padding: "6px", verticalAlign: "middle", backgroundColor: "#d1ecf1" }}>
//                       Day Diff
//                     </th>
//                   </tr>
//                   <tr>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Qty</th>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Value</th>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Qty</th>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Value</th>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Qty</th>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Value</th>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Qty</th>
//                     <th style={{ textAlign: "right", padding: "6px" }}>Value</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {sortedData[group].map((row, rowIndex) => (
//                     <tr key={rowIndex}>
//                       <td style={{ textAlign: "center", padding: "4px" }}>
//                         {formatDate(row.doc_date)}
//                        </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "right", padding: "4px" }}>
//                         {formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2))}
//                       </td>
//                       <td style={{ textAlign: "center", padding: "4px" }}>
//                         {formatReadableAmount(
//                           ((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//                 <tfoot style={{ backgroundColor: "#e0e0e0", fontWeight: "bold" }}>
//                   <tr>
//                     <td style={{ textAlign: "center", padding: "6px" }}>Total</td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>-</td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>-</td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount(sortedData[group]
//                         .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
//                         .toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount(sortedData[group]
//                         .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
//                         .toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount(sortedData[group]
//                         .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
//                         .toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>
//                       {formatReadableAmount(sortedData[group]
//                         .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
//                         .toFixed(2))}
//                     </td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>-</td>
//                     <td style={{ textAlign: "right", padding: "6px" }}>-</td>
//                     <td style={{ textAlign: "center", padding: "6px" }}>-</td>
//                   </tr>
//                 </tfoot>
//               </table>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default StockBookReport;



















import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import PdfPreview from "../../../Common/PDFPreview";
import { RingLoader } from 'react-spinners';
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount"
import BackButton from "../../../Common/Buttons/BackButton";

const API_URL = process.env.REACT_APP_API;

const StockBookReport = () => {
  const location = useLocation();
  const companyCode = sessionStorage.getItem("Company_Code");
  const Year_Code = sessionStorage.getItem("Year_Code");
  const companyName = sessionStorage.getItem('Company_Name')

  const searchParams = new URLSearchParams(location.search);
  const itemCode = searchParams.get('itemCode');
  const toDate = searchParams.get('toDate');
  const fromDate = searchParams.get('fromDate');

  const [groupedData, setGroupedData] = useState({});
  const [sortedData, setSortedData] = useState({});
  const [loading, setLoading] = useState(true);
  const [pdfPreview, setPdfPreview] = useState([])
  const [showPreview, setShowPreview] = useState(false);
  const [sortConfig, setSortConfig] = useState({});
  const reportRef = useRef();

  const navigate = useNavigate();

  const groupBy = (array, key) => {
    const grouped = array.reduce((result, currentItem) => {
      const groupKey = currentItem[key];
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(currentItem);
      return result;
    }, {});

    const sortedKeys = Object.keys(grouped).sort((a, b) =>
      a.localeCompare(b)
    );

    const sortedGrouped = {};
    sortedKeys.forEach((key) => {
      sortedGrouped[key] = grouped[key];
    });

    return sortedGrouped;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const sortData = (data, column, direction) => {
    if (!data || !Array.isArray(data)) return [];

    const sorted = [...data];

    sorted.sort((a, b) => {
      let aValue, bValue;

      switch (column) {
        case 'date':
          aValue = new Date(a.doc_date).getTime();
          bValue = new Date(b.doc_date).getTime();
          break;
        case 'opening_qty':
          aValue = parseFloat(a.op_qty) || 0;
          bValue = parseFloat(b.op_qty) || 0;
          break;
        case 'opening_value':
          aValue = parseFloat(a.op_value) || 0;
          bValue = parseFloat(b.op_value) || 0;
          break;
        case 'purchase_qty':
          aValue = parseFloat(a.purc_qty) || 0;
          bValue = parseFloat(b.purc_qty) || 0;
          break;
        case 'purchase_value':
          aValue = parseFloat(a.purc_value) || 0;
          bValue = parseFloat(b.purc_value) || 0;
          break;
        case 'sale_qty':
          aValue = parseFloat(a.sale_qty) || 0;
          bValue = parseFloat(b.sale_qty) || 0;
          break;
        case 'sale_value':
          aValue = parseFloat(a.sale_val) || 0;
          bValue = parseFloat(b.sale_val) || 0;
          break;
        case 'closing_qty':
          aValue = parseFloat(a.close_qty) || 0;
          bValue = parseFloat(b.close_qty) || 0;
          break;
        case 'closing_value':
          aValue = parseFloat(a.close_val) || 0;
          bValue = parseFloat(b.close_val) || 0;
          break;
        case 'day_diff':
          aValue = (parseFloat(a.purc_qty) || 0) - (parseFloat(a.sale_qty) || 0);
          bValue = (parseFloat(b.purc_qty) || 0) - (parseFloat(b.sale_qty) || 0);
          break;
        default:
          aValue = a[column];
          bValue = b[column];
      }

      if (direction === 'asc') {
        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
      } else {
        if (aValue > bValue) return -1;
        if (aValue < bValue) return 1;
        return 0;
      }
    });

    return sorted;
  };

  const handleSort = (groupKey, column) => {
    setSortConfig(prevConfig => {
      const currentConfig = prevConfig[groupKey];

      let newDirection;

      if (!currentConfig || currentConfig.column !== column) {
        newDirection = 'asc';
      } else if (currentConfig.column === column && currentConfig.direction === 'asc') {
        newDirection = 'desc';
      } else if (currentConfig.column === column && currentConfig.direction === 'desc') {
        newDirection = null;
      } else {
        newDirection = 'asc';
      }

      const newConfig = { ...prevConfig };

      if (newDirection) {
        newConfig[groupKey] = { column, direction: newDirection };
        const sortedGroupData = sortData(groupedData[groupKey], column, newDirection);

        setSortedData(prev => ({
          ...prev,
          [groupKey]: sortedGroupData
        }));
      } else {
        delete newConfig[groupKey];
        setSortedData(prev => ({
          ...prev,
          [groupKey]: [...groupedData[groupKey]]
        }));
      }

      return newConfig;
    });
  };

  const getSortIcon = (groupKey, column) => {
    const config = sortConfig[groupKey];
    if (config && config.column === column) {
      return config.direction === 'asc' ? ' ↑' : ' ↓';
    }
    return ' ⇅';
  };

  useEffect(() => {
    const fetchStockBookReport = async () => {
      try {
        const response = await fetch(
          `${API_URL}/report-stock-book?fromDate=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode}&ToDate=${toDate}&Year_Code=${Year_Code} `
        );
        const result = await response.json();
        const filteredData = result.data.filter((item) => {
          const docDate = new Date(item.doc_date);
          const from = new Date(fromDate);
          const to = new Date(toDate);
          return docDate >= from && docDate <= to;
        });

        const grouped = groupBy(filteredData, "item_name");
        setGroupedData(grouped);
        const initialSorted = {};
        Object.keys(grouped).forEach(key => {
          initialSorted[key] = [...grouped[key]];
        });
        setSortedData(initialSorted);
      } catch (error) {
        console.error("Error fetching stock book report:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStockBookReport();
  }, [toDate, fromDate, companyCode, Year_Code, itemCode]);

  const handleBack = () => {
    navigate('/stock-book')
  }

  // Fixed Print Function - Landscape with better scaling
  const handlePrint = () => {
    const printContent = reportRef.current.cloneNode(true);

    // Create a new window for printing
    const printWindow = window.open('', '_blank', 'width=1200,height=800');

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Stock Book Report - ${companyName}</title>
          <meta charset="utf-8" />
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Arial', 'Helvetica', sans-serif;
              margin: 0;
              padding: 20px;
              background: white;
              font-size: 11px;
            }
            
            @page {
              size: landscape;
              margin: 15mm 10mm;
            }
            
            .print-container {
              max-width: 100%;
              margin: 0 auto;
            }
            
            .header {
              text-align: center;
              margin-bottom: 25px;
              page-break-after: avoid;
            }
            
            .company-name {
              font-size: 22px;
              font-weight: bold;
              margin-bottom: 8px;
              color: #000;
            }
            
            .report-title {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 8px;
              color: #000;
            }
            
            .date-range {
              font-size: 12px;
              margin-bottom: 15px;
              color: #333;
            }
            
            .item-section {
              margin-bottom: 30px;
              page-break-inside: avoid;
              break-inside: avoid;
            }
            
            .item-header {
              background-color: #f0f0f0;
              padding: 8px 12px;
              margin: 15px 0 10px 0;
              font-weight: bold;
              font-size: 13px;
              border-left: 4px solid #2196F3;
              page-break-after: avoid;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
              margin-bottom: 20px;
              page-break-inside: avoid;
              break-inside: avoid;
            }
            
            th, td {
              border: 1px solid #000;
              padding: 6px 4px;
              text-align: right;
            }
            
            th:first-child, td:first-child {
              text-align: center;
            }
            
            th {
              background-color: #e0e0e0;
              font-weight: bold;
              font-size: 10px;
            }
            
            tbody tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            
            tfoot td {
              background-color: #e0e0e0;
              font-weight: bold;
            }
            
            .opening-header {
              background-color: #e8f4f8;
            }
            
            .purchase-header {
              background-color: #d4edda;
            }
            
            .sale-header {
              background-color: #f8d7da;
            }
            
            .closing-header {
              background-color: #fff3cd;
            }
            
            .daydiff-header {
              background-color: #d1ecf1;
            }
            
            /* Ensure tables don't break across pages badly */
            tr {
              page-break-inside: avoid;
              break-inside: avoid;
            }
            
            /* Responsive table container */
            .table-wrapper {
              overflow-x: auto;
              width: 100%;
              margin-bottom: 20px;
            }
            
            @media print {
              body {
                padding: 0;
                margin: 0;
              }
              
              button, .no-print {
                display: none !important;
              }
              
              table {
                font-size: 9px;
              }
              
              th, td {
                padding: 4px 3px;
              }
              
              .item-section {
                page-break-after: avoid;
                break-after: avoid;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-container">
            ${printContent.innerHTML}
          </div>
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            };
          <\/script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  const exportToExcel = () => {
    const excelData = [];

    excelData.push(['Company Name', companyName]);
    excelData.push(['Report', 'Stock Book Report']);
    excelData.push(['From Date', formatDate(fromDate)]);
    excelData.push(['To Date', formatDate(toDate)]);
    excelData.push([]);

    Object.keys(sortedData).forEach((group) => {
      excelData.push([`Item: ${group.toUpperCase()}`]);
      excelData.push([]);

      excelData.push([
        'Date',
        'Opening Qty (Quintals)',
        'Opening Value',
        'Purchase Qty (Quintals)',
        'Purchase Value',
        'Sale Qty (Quintals)',
        'Sale Value',
        'Closing Qty (Quintals)',
        'Closing Value',
        'Day Diff'
      ]);

      sortedData[group].forEach((row) => {
        excelData.push([
          formatDate(row.doc_date),
          formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
          formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
          formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
          formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
          formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
          formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
          formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
          formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
          formatReadableAmount(
            ((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)
          )
        ]);
      });

      excelData.push([
        'TOTAL',
        '',
        '',
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
          .toFixed(2)),
        '',
        '',
        ''
      ]);

      excelData.push([]);
      excelData.push([]);
    });

    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Set column widths
    ws['!cols'] = [
      { wch: 12 },  // Date
      { wch: 18 },  // Opening Qty
      { wch: 15 },  // Opening Value
      { wch: 18 },  // Purchase Qty
      { wch: 15 },  // Purchase Value
      { wch: 15 },  // Sale Qty
      { wch: 15 },  // Sale Value
      { wch: 18 },  // Closing Qty
      { wch: 15 },  // Closing Value
      { wch: 12 }   // Day Diff
    ];

    // Apply right alignment to all amount columns (all except Date column)
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (!ws[cellAddress]) continue;

        // Right align all amount columns (columns 1-9, excluding Date column 0)
        if (col >= 1 && col <= 9) {
          if (!ws[cellAddress].s) ws[cellAddress].s = {};
          ws[cellAddress].s.alignment = { horizontal: 'right' };
        }
        // Center align Date column (column 0)
        if (col === 0) {
          if (!ws[cellAddress].s) ws[cellAddress].s = {};
          ws[cellAddress].s.alignment = { horizontal: 'center' };
        }
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stock Book Report');

    const fileName = `Stock_Book_Report_${formatDate(fromDate)}_to_${formatDate(toDate)}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  const generatePDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;
    const margin = 10;
    const pageWidth = doc.internal.pageSize.width;

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    const companyNameWidth = doc.getTextWidth(companyName || "Company Name");
    const companyNameX = (pageWidth - companyNameWidth) / 2;
    doc.text(companyName, companyNameX, 10);

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const titleWidth = doc.getTextWidth("Stock Book Report");
    const titleX = (pageWidth - titleWidth) / 2;
    doc.text("Stock Book Report", titleX, 18);

    doc.setFontSize(10);
    const dateRangeText = `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`;
    const dateRangeWidth = doc.getTextWidth(dateRangeText);
    const dateRangeX = (pageWidth - dateRangeWidth) / 2;
    doc.text(dateRangeText, dateRangeX, 24);

    let currentY = 34;
    Object.keys(sortedData).forEach((group, groupIndex) => {
      if (currentY + 20 > pageHeight - margin) {
        doc.addPage();
        currentY = margin;
      }

      doc.setFontSize(11);
      doc.setTextColor(40);
      doc.setFont("helvetica", "bold");
      const itemText = `Item Name: ${group.toUpperCase()}`;
      const itemTextWidth = doc.getTextWidth(itemText);
      const itemTextX = (pageWidth - itemTextWidth) / 2;
      doc.text(itemText, itemTextX, currentY);
      currentY += 8;

      const tableData = sortedData[group].map((row) => [
        formatDate(row.doc_date),
        formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
        formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
        formatReadableAmount(((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)),
      ]);

      const totalRow = [
        "Total",
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.op_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.op_value) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.close_qty) || 0), 0)
          .toFixed(2)),
        formatReadableAmount(sortedData[group]
          .reduce((sum, item) => sum + (parseFloat(item.close_val) || 0), 0)
          .toFixed(2)),
        "",
      ];

      doc.autoTable({
        startY: currentY,
        head: [
          [
            "Date",
            "Opening Qty",
            "Opening Value",
            "Purchase Qty",
            "Purchase Value",
            "Sale Qty",
            "Sale Value",
            "Closing Qty",
            "Closing Value",
            "Day Diff",
          ],
        ],
        body: [...tableData, totalRow],
        styles: { fontSize: 7, cellPadding: 2, halign: "right" },
        headStyles: { fillColor: [240, 240, 240], textColor: 0, halign: "center", fontSize: 7 },
        columnStyles: {
          0: { halign: "center", cellWidth: 25 },
          1: { cellWidth: 22 },
          2: { cellWidth: 25 },
          3: { cellWidth: 22 },
          4: { cellWidth: 25 },
          5: { cellWidth: 22 },
          6: { cellWidth: 25 },
          7: { cellWidth: 22 },
          8: { cellWidth: 25 },
          9: { halign: "right", cellWidth: 20 }
        },
        margin: { left: 10, right: 10 },
        didDrawPage: (data) => {
          currentY = data.cursor.y;
        },
      });

      currentY = doc.lastAutoTable.finalY + 8;
    });

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    setPdfPreview(pdfUrl);
    setShowPreview(true);
  };

  const TableHeader = ({ groupKey, column, label, style }) => (
    <th
      style={{
        textAlign: "right",
        padding: "8px",
        cursor: "pointer",
        userSelect: "none",
        position: "relative",
        transition: "background-color 0.2s",
        ...style
      }}
      onClick={() => handleSort(groupKey, column)}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e0e0e0"}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = style?.backgroundColor || "#f0f0f0"}
      title={`Click to sort`}
    >
      {label}
      <span style={{ marginLeft: "8px", fontSize: "11px", fontWeight: "normal" }}>
        {getSortIcon(groupKey, column)}
      </span>
    </th>
  );

  if (loading) return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}>
      <RingLoader />
    </div>
  );

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px' }} className="no-print">
        <BackButton onClick={handleBack} />
        {showPreview && pdfPreview && (
          <PdfPreview pdfData={pdfPreview} apiData={sortedData} label={"Stock-Report"} />
        )}
        <button
          onClick={handlePrint}
          style={{ fontSize: "14px", padding: "10px 20px", height: "50px", cursor: "pointer", backgroundColor: "#4CAF50", color: "white", border: "none", borderRadius: "4px" }}
        >
          Print
        </button>
        <button
          onClick={exportToExcel}
          style={{ fontSize: "14px", padding: "10px 20px", height: "50px", cursor: "pointer", backgroundColor: "#2196F3", color: "white", border: "none", borderRadius: "4px" }}
        >
          Export to Excel
        </button>
      </div>

      {/* Print Content */}
      <div ref={reportRef}>
        <div className="header" style={{ textAlign: "center", marginBottom: "25px" }}>
          <div style={{ fontSize: "22px", fontWeight: "bold", marginBottom: "8px" }}>
            {companyName}
          </div>
          <div style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "8px" }}>
            Stock Book Report
          </div>
          <div style={{ fontSize: "12px", marginBottom: "15px" }}>
            <strong>From Date:</strong> {formatDate(fromDate)} |{" "}
            <strong>To Date:</strong> {formatDate(toDate)}
          </div>
        </div>

        {Object.keys(sortedData).map((group, index) => (
          <div key={index} className="item-section" style={{ marginBottom: "30px" }}>
            <div className="item-header" style={{
              backgroundColor: "#f4f4f4",
              padding: "8px 12px",
              marginBottom: "10px",
              fontWeight: "bold",
              fontSize: "14px"
            }}>
              {group.toUpperCase()}
            </div>
            <div className="table-wrapper">
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "11px" }}>
                <thead>
                  <tr>
                    <th rowSpan="2" style={{ textAlign: "center", padding: "6px", verticalAlign: "middle", backgroundColor: "#f0f0f0", fontSize: "11px" }}>
                      Date
                    </th>
                    <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#e8f4f8", fontSize: "11px" }}>
                      Opening
                    </th>
                    <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#d4edda", fontSize: "11px" }}>
                      Purchase
                    </th>
                    <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#f8d7da", fontSize: "11px" }}>
                      Sale
                    </th>
                    <th colSpan="2" style={{ textAlign: "center", padding: "6px", backgroundColor: "#fff3cd", fontSize: "11px" }}>
                      Closing
                    </th>
                    <th rowSpan="2" style={{ textAlign: "center", padding: "6px", verticalAlign: "middle", backgroundColor: "#d1ecf1", fontSize: "11px" }}>
                      Day Diff
                    </th>
                  </tr>
                  <tr>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Value</th>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Value</th>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Value</th>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Qty</th>
                    <th style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData[group].map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td style={{ textAlign: "center", padding: "4px", fontSize: "11px" }}>
                        {formatDate(row.doc_date)}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "right", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2))}
                      </td>
                      <td style={{ textAlign: "center", padding: "4px", fontSize: "11px" }}>
                        {formatReadableAmount(
                          ((parseFloat(row.purc_qty) || 0) - (parseFloat(row.sale_qty) || 0)).toFixed(2)
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot style={{ backgroundColor: "#e0e0e0", fontWeight: "bold" }}>
                  <tr>
                    <td style={{ textAlign: "center", padding: "6px", fontSize: "11px" }}>Total</td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>-</td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>-</td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>
                      {formatReadableAmount(sortedData[group]
                        .reduce((sum, item) => sum + (parseFloat(item.purc_qty) || 0), 0)
                        .toFixed(2))}
                    </td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>
                      {formatReadableAmount(sortedData[group]
                        .reduce((sum, item) => sum + (parseFloat(item.purc_value) || 0), 0)
                        .toFixed(2))}
                    </td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>
                      {formatReadableAmount(sortedData[group]
                        .reduce((sum, item) => sum + (parseFloat(item.sale_qty) || 0), 0)
                        .toFixed(2))}
                    </td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>
                      {formatReadableAmount(sortedData[group]
                        .reduce((sum, item) => sum + (parseFloat(item.sale_val) || 0), 0)
                        .toFixed(2))}
                    </td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>-</td>
                    <td style={{ textAlign: "right", padding: "6px", fontSize: "11px" }}>-</td>
                    <td style={{ textAlign: "center", padding: "6px", fontSize: "11px" }}>-</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockBookReport;
